import { useMemo, useState } from 'react';
import { computeOptimalBundle } from '../../../engine/procurementAI';

export function ProcurementOptimizer() {
  const [suppliers, setSuppliers] = useState([
    { id:'s1', name:'Alpha', rating:70, co2PerUnit:5, pricePerUnit:10 },
    { id:'s2', name:'Beta', rating:60, co2PerUnit:6, pricePerUnit:9 },
    { id:'s3', name:'Gamma', rating:80, co2PerUnit:4, pricePerUnit:11 }
  ]);
  const result = useMemo(()=> computeOptimalBundle(suppliers, 90), [suppliers]);

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Procurement Optimizer</div>
      <div className="text-sm text-neutral-400">Compliance gain: <span className="text-evat-neon">+{result.complianceGain}</span></div>
      <div className="border border-neutral-700 rounded p-2 text-sm">
        <div>Expected CO2: <span className="text-evat-gold">{result.expectedCo2}</span> • Cost: <span className="text-evat-neon">€{result.cost}</span></div>
        <div className="mt-2">Bundle:</div>
        <ul className="list-disc ml-5">
          {result.picks.map(p => <li key={p.supplierId}>{p.supplierId}: {p.units} units</li>)}
        </ul>
      </div>
      <button className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:bg-evat-neon/20 transition-colors">Apply (demo)</button>
    </div>
  );
}

export default ProcurementOptimizer;












